import * as Dialog from '@radix-ui/react-dialog';
import * as React from 'react';
import './professional-context-form.scss';

interface Props {
  open: boolean;
  onDiscard: () => void;
  onKeepEditing: () => void;
}

export function CancelConfirmDialog({
  open,
  onDiscard,
  onKeepEditing,
}: Props): React.ReactElement | null {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(o) => {
        if (!o) onKeepEditing();
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="plan-c-form__dialog-overlay" />
        <Dialog.Content className="plan-c-form__dialog-content">
          <Dialog.Title className="plan-c-form__dialog-title">
            Discard changes?
          </Dialog.Title>
          <Dialog.Description className="plan-c-form__dialog-body">
            Your edits haven't been saved. If you discard, you'll lose them.
          </Dialog.Description>
          <div className="plan-c-form__dialog-actions">
            <button
              type="button"
              className="plan-c-form__button-secondary"
              onClick={onKeepEditing}
            >
              Keep editing
            </button>
            <button
              type="button"
              className="plan-c-form__button-danger"
              onClick={onDiscard}
            >
              Discard
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
